import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

interface FindAdvisorsParams {
  email: string;
}

interface AdvisorDTO {
  AdviserId: number;
  FirstName: string;
  IsManager: boolean;
  IsOwner: boolean;
  IsRemovable: boolean;
  LastName: string;
}

const findAdvisors = async ({ email }: FindAdvisorsParams): Promise<AdvisorDTO[]> =>
  authFetch('/Adviser/Adviser/Find', {
    method: 'POST',
    ...httpBodyOptions({ email, accessToCampaigns: true }, true),
  });

export const useFindAdvisorsMutation = () => {
  return useMutation(findAdvisors);
};
